import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Signin2 from "../pages/Signin2";
import useManagePatient from "../hooks/patientDashboard/useManagePatient";
import AIChatWidget from "../components/aiAssistant/AIChatWidget";

export default function Main() {

  const offsets = ["/apps/file-manager", "/apps/email", "/apps/calendar"];
  const { pathname } = useLocation();
  const bc = document.body.classList;

  // set sidebar to offset
  (offsets.includes(pathname)) ? bc.add("sidebar-offset") : bc.remove("sidebar-offset");

  // auto close sidebar when switching pages in mobile
  bc.remove("sidebar-show");

  // scroll to top when switching pages
  window.scrollTo(0, 0);
  const {findPatient,currentUser } = useManagePatient()

  // useEffect(() => {
  //  findPatient()
  // }, [])

  
  

  return (
    <React.Fragment>
      <Sidebar />
{/* <Signin2/> */}
      <Outlet />

      <AIChatWidget />

    </React.Fragment>
  )
}